import type { QuestionFigureData } from '../lib/api-types';

/**
 * The picture of a code-drawn question (mirror images, counting figures, figure series). The SVG
 * is shown as an image (never inlined as markup), full width so its lines stay sharp on phones.
 */
export function QuestionFigure({ figure }: { figure: QuestionFigureData }) {
  return (
    <img
      src={`data:image/svg+xml;charset=utf-8,${encodeURIComponent(figure.svg)}`}
      alt={figure.alt}
      className="w-full rounded-lg border border-input bg-white"
      draggable={false}
    />
  );
}
